import { gql } from "@apollo/client";

export const GET_ALL_JOB_DAYS_WITH_FULL_DETAIL = gql`
    query allJobDays {
        id

        date
        startTime

        safetyNotes
        scopeOfWork
        vehicleOption

        customerSignature
        emailReceiptSent
        emailReceiptRecipient

        createdBy {
            id
            firstName
            lastName
        }
        lastUpdatedBy {
            id
            firstName
            lastName
        }
    }
`

export const GET_JOB_DAY_BY_ID_WITH_FULL_DETAIL = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            id

            date
            startTime

            safetyNotes
            scopeOfWork
            vehicleOption

            customerSignature
            emailReceiptSent
            emailReceiptRecipient

            createdBy {
                id
                firstName
                lastName
            }
            lastUpdatedBy {
                id
                firstName
                lastName
            }   
        }
    }
`

export const GET_JOB_DAY_BY_ID_FOR_EDIT_FORM = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            id

            job {
                id
                name
            }

            truck {
                id
            }

            driver {
                id
            }

            truck2 {
                id
            }

            driver2 {
                id
            }

            truck3 {
                id
            }

            driver3 {
                id
            }

            scopeOfWork
            vehicleOption
            date
            startTime
            endTime

            crewMemberAssignments {
                id
                crewMember {
                    id
                    firstName
                    lastName
                    classification
                }
            }
        }
    }
`

// Job Day - Date & Job Name
export const GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            date
            vehicleOption
            job {
                name
            }
            crewMemberAssignments {
                endTime
                preliminaryApproval
                finalApproval
                isPaid
                paidDate
                crewMember {
                    firstName
                    lastName
                    isForeman
                }
            }
        }
    }
`

// Job Day - Job Info
export const GET_JOB_DAY_BY_ID_WITH_JOB_INFO = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            scopeOfWork
            vehicleOption
            truck {
                number
            }
            driver {
                firstName
                lastName
            }

            truck2 {
                number
            }
            driver2 {
                firstName
                lastName
            }

            truck3 {
                number
            }
            driver3 {
                firstName
                lastName
            }
            job {
                id

                street1
                street2
                city
                state
                zipcode
            }
        }
    }
`

// Job Day - Time Ticket Stats
export const GET_JOB_DAY_BY_ID_WITH_TIME_TICKET_STATS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            workType1
            workType2
            workType
            numFrames
        }
    }
`

// Job Days in Date Range
export const GET_ALL_JOB_DAYS_IN_DATE_RANGE = gql`
    query jobDaysInDateRange($startDate: Date!, $endDate: Date!) {
        jobDaysInDateRange(startDate: $startDate, endDate: $endDate) {
            id
            date
            vehicleOption
            job {
                name
            }
            startTime
            endTime
        }
    }
`

// Job Day Crew Assignments
export const GET_JOB_DAY_CREW_ASSIGNMENTS = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            crewMemberAssignments {
                id
                crewMember {
                    firstName
                    lastName
                    isForeman
                    classification
                }

                startTime
                endTime
                jobDay {
                    date
                }

                assignmentNotifications {
                    id
                    datetimeCreated
                }
            }
        }
    }
`

export const GET_JOB_DAY_INFO_FOR_PDF = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id){
            id
            date
            safetyNotes
            scopeOfWork
            vehicleOption
            workType
            workType1
            workType2
            numFrames
            customerSignature
            customerComments
            job {
                name
                customerName
                customerPhone
                customerContactName
                street1
                street2
                city
                state
                zipcode
                wageRate
            }
            truck {
                number
            }
            driver {
                firstName
                lastName
            }
            crewMemberAssignments {
                crewMember {
                    firstName
                    lastName
                    classification
                }
                startTime
                endTime
                preliminaryApproval
                finalApproval
                isPaid
                paidDate
                signOff {
                    signature
                }
                jobDay {
                    date
                }
            }
        }
    }
`

export const GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_APPROVAL = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            job {
                name
            }
            scopeOfWork
            vehicleOption
            crewMemberAssignments {
                id
                crewMember {
                    firstName
                    lastName
                    isForeman
                    classification
                }

                startTime
                endTime
                preliminaryApproval
                finalApproval
                isPaid
                paidDate
                signOff {
                    signature
                }
            }
        }
    }
`

export const GET_JOB_DAY_BY_ID_WITH_ASSIGNMENTS_FOR_FINISH_TIME_TICKETS_FORM = gql`
    query jobDay($id: Int!) {
        jobDay(id: $id) {
            job {
                name
            }
            scopeOfWork
            vehicleOption
            crewMemberAssignments {
                id
                crewMember {
                    firstName
                    lastName
                    isForeman
                    classification
                }
                startTime
                endTime

            }
        }
    }
`
